export const toCurrency = (amount: number, currency = 'SEK'): string => {
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: currency
  }).format(amount);
};

export const formatNumber = (number: number): string => {
  return new Intl.NumberFormat('sv-SE', {}).format(number);
};

export const toPercent = (amount: number, of: number, maxDecimals?: number): string => {
  return (
    new Intl.NumberFormat('sv-SE', {
      style: 'decimal',
      minimumFractionDigits: 1,
      maximumFractionDigits: maxDecimals || 2
    }).format(of ? (amount / of) * 100 : 0) + '%'
  );
};

export const decimalToPercent = (decimal: number): string => {
  return (
    new Intl.NumberFormat('sv-SE', {
      style: 'decimal',
      minimumFractionDigits: 1,
      maximumFractionDigits: 2
    }).format(decimal ? decimal * 100 : 0) + '%'
  );
};

export const toNumericId = (value: string | number): number => Number(value);

// returns a random number between min and max
export const randomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const isEven = (number: number) => !!(number % 2 == 0);

type GetHighestNumberFn = {
  (values: (number | string)[]): number;
  <T>(items: T[], idField: keyof T): number;
};

/**
 * Retrieves the highest number either:
 * 1. From an array of numbers or strings that represent numbers.
 * 2. From an array of objects based on the specified field.
 */
export const getHighestNumber: GetHighestNumberFn = <T>(
  items?: (number | string)[] | T[],
  idField?: keyof T
): number => {
  if (!items) return 0;
  if (idField) {
    const values = (items as T[])?.map((item) => item[idField as keyof T]) as (number | string)[];
    return getMaxFromMixedArray(values);
  }
  return getMaxFromMixedArray(items as (number | string)[]);
};

const getMaxFromMixedArray = (values: (number | string)[]): number => {
  const nums = values
    .map((value) => (typeof value === 'string' ? parseInt(value, 10) : value))
    .filter((v) => !isNaN(v));
  return Math.max(...nums, 0);
};
